import React from 'react';
import { Users, Timer, Calendar, TrendingUp, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import MetricCard from "@/components/dashboard/MetricCard";
import DashboardSection from "@/components/dashboard/DashboardSection";
import ResponsiveContainer from "@/components/dashboard/ResponsiveContainer";

const CoachDashboard = () => {
  const metrics = [
    { 
      icon: <Users className="h-5 w-5 sm:h-6 sm:w-6" />, 
      label: "Active Swimmers", 
      value: "32",
      trend: { value: 4, isPositive: true }
    },
    { 
      icon: <Timer className="h-5 w-5 sm:h-6 sm:w-6" />, 
      label: "Training Hours", 
      value: "128",
      trend: { value: 12, isPositive: true }
    },
    { 
      icon: <Calendar className="h-5 w-5 sm:h-6 sm:w-6" />, 
      label: "Upcoming Events", 
      value: "5",
      trend: { value: 2, isPositive: true }
    },
    { 
      icon: <TrendingUp className="h-5 w-5 sm:h-6 sm:w-6" />, 
      label: "Team Progress", 
      value: "92%",
      trend: { value: 8, isPositive: true }
    }
  ];

  return (
    <ResponsiveContainer>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">Coach Dashboard</h2>
        <Button size="sm" className="w-full sm:w-auto">
          <Plus className="mr-2 h-4 w-4" /> Schedule Training
        </Button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {metrics.map((metric, index) => (
          <MetricCard key={index} {...metric} />
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
        <DashboardSection
          title="Upcoming Sessions"
          description="Next scheduled training sessions"
          action={<Button variant="outline" size="sm" className="w-full sm:w-auto">View Schedule</Button>}
        >
          <div className="space-y-3 sm:space-y-4">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between py-2 gap-2">
              <div>
                <p className="font-medium">Morning Training</p>
                <p className="text-xs sm:text-sm text-muted-foreground">Today, 6:00 AM - 8:00 AM</p>
              </div>
              <Button variant="ghost" size="sm" className="w-full sm:w-auto">Details</Button>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between py-2 gap-2">
              <div>
                <p className="font-medium">Evening Training</p>
                <p className="text-xs sm:text-sm text-muted-foreground">Today, 4:00 PM - 6:00 PM</p>
              </div>
              <Button variant="ghost" size="sm" className="w-full sm:w-auto">Details</Button>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between py-2 gap-2">
              <div>
                <p className="font-medium">Competition Prep</p>
                <p className="text-xs sm:text-sm text-muted-foreground">Tomorrow, 9:00 AM - 11:00 AM</p>
              </div>
              <Button variant="ghost" size="sm" className="w-full sm:w-auto">Details</Button>
            </div>
          </div>
        </DashboardSection>

        <DashboardSection
          title="Team Performance"
          description="Recent achievements and progress"
          action={<Button variant="outline" size="sm" className="w-full sm:w-auto">Full Report</Button>}
        >
          <div className="space-y-4">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
              <div className="w-full sm:w-3/4 space-y-1">
                <p className="text-sm font-medium">Attendance Rate</p>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-blue-600 h-2 rounded-full" style={{ width: '88%' }}></div>
                </div>
              </div>
              <span className="text-sm font-medium">88%</span>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
              <div className="w-full sm:w-3/4 space-y-1">
                <p className="text-sm font-medium">Goal Achievement</p>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-green-600 h-2 rounded-full" style={{ width: '75%' }}></div>
                </div>
              </div>
              <span className="text-sm font-medium">75%</span>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
              <div className="w-full sm:w-3/4 space-y-1">
                <p className="text-sm font-medium">Training Completion</p>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-orange-600 h-2 rounded-full" style={{ width: '92%' }}></div>
                </div>
              </div>
              <span className="text-sm font-medium">92%</span>
            </div>
          </div>
        </DashboardSection>
      </div>
    </ResponsiveContainer>
  );
};

export default CoachDashboard; 